<template>
	<el-container style="width: 80%; margin: 0 auto">
		<BreadCrumb></BreadCrumb>
		<el-card v-loading="loading" class="pay-type" loading-text="加载中，请稍等..." shadow="never">
			<div slot="header">
				<div class="flex" style="align-items: center">
					<h3>支付宝支付</h3>
					<div class="countdown-timer">
						<span v-if="countdown > 0" class="timer-text">订单将在 {{ formatTime(countdown) }} 后失效，请尽快支付！</span>
						<span v-else class="timer-expired">订单已失效，请刷新重新生成二维码！</span>
					</div>
				</div>
			</div>
			<div style="overflow: hidden; width: 50%; margin: 40px auto 100px">
				<div class="tab-pane-left">
					<h6 v-show="$route.query.productName">VIP会员{{ $route.query.productName }}</h6>
					<div>扫一扫付款（元）</div>
					<div class="flexStart">
						<div class="money" v-if="orderInfo">{{ (Number(orderInfo.orderBasic.totalAmount) + Number(orderInfo.orderBasic.freightAmount)).toFixed(2) }}</div>
						<span v-if="orderInfo.orderBasic.freightAmount > 0">(包含{{ orderInfo.orderBasic.freightAmount }}元运费)</span>
					</div>
					<div class="qrcode-container">
						<div id="ali-qrcode" class="qrcode"></div>
						<div v-if="countdown <= 0" class="qrcode-overlay">
							<div class="refresh-icon" @click="refreshQRCode">
								<i class="el-icon-refresh"></i>
								<span>刷新二维码</span>
							</div>
						</div>
					</div>
					<div>订单号：{{ $route.query.orderId }}</div>
					<el-button plain size="small" style="margin-top: 20px" type="primary" @click="viewOrder(false)">查看订单</el-button>
				</div>
				<div class="tab-pane-right">
					<div class="tab-pane-right-img">
						<img alt="" src="../../assets/images/aliPay.png" />
					</div>
				</div>
			</div>
		</el-card>
	</el-container>
</template>
<script>
import QRCode from 'qrcodejs2';
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import { getConsumerOrderPayAlibaba, getConsumerOrderPayAlibabaStatus } from '@/api/order/pay';
import { getConsumerOrderInfo } from '@/api/order/order';
import { mapActions } from 'vuex';
export default {
	name: 'AliPay',
	data() {
		return {
			// 5分钟倒计时（300秒）
			countdown: 300,
			// 倒计时定时器
			countdownTimer: null,
			// 支付状态轮询定时器
			paymentTimer: null,
			loading: true,
			// 当前二维码内容
			currentQRCode: '',
			radio: 2,
			orderInfo: null
		};
	},
	watch: {
		// 监听倒计时
		countdown(val) {
			if (val <= 0) {
				this.clearTimers();
				// this.$message.warning('订单已失效，请刷新二维码重新支付');
			}
		}
	},
	components: {
		BreadCrumb
	},
	mounted() {
		this.getOrderInfo();
		this.$nextTick(() => {
			this.initPayment();
		});
		const listPath = this.$route.query.orderId.indexOf('VIP') >= 0 ? '/UserCenter/VIPOrder' : '/UserCenter/BookOrder';
		const breadcrumbs = [
			{
				path: '/Home',
				name: '首页'
			},
			{
				path: listPath,
				name: '我的订单'
			},
			{
				path: '/OrderDet?orderId=' + this.$route.query.orderId,
				name: '订单详情'
			},
			{ name: '订单支付' }
		];
		this.setBreadcrumbList(breadcrumbs);
	},
	beforeDestroy() {
		this.clearTimers();
	},
	methods: {
		...mapActions('Settings', ['setBreadcrumbList', 'setLoginShow']),
		...mapActions('User', ['logout']),
		//获取订单信息
		async getOrderInfo() {
			let res = await getConsumerOrderInfo(this.$route.query.orderId);
			if (res.code === 200) {
				this.orderInfo = res.data;
			}
		},
		// 初始化支付流程
		async initPayment() {
			this.loading = true;
			await this.getConsumerOrderPayAlibaba();
		},

		// 开始5分钟倒计时
		startCountdown() {
			this.countdownTimer = setInterval(() => {
				this.countdown--;
			}, 1000);
		},

		// 开始支付状态轮询
		startPaymentPolling() {
			this.paymentTimer = setInterval(() => {
				this.checkPaymentStatus();
			}, 3000);
		},

		// 检查支付状态
		async checkPaymentStatus() {
			getConsumerOrderPayAlibabaStatus(this.$route.query.orderId).then(res => {
				if (res.code == 200) {
					if (res.data.payStatus > 1) {
						this.clearTimers();
						//订单编号包含VIP
						if (this.$route.query.orderId.indexOf('VIP') >= 0) {
							this.$message({
								message: 'VIP会员订单已完成，需要重新登录才可更新会员状态!',
								type: 'success',
								duration: 7000
							});
							setTimeout(() => {
								this.logout().then(() => {
									this.setLoginShow(true);
								});
							}, 5000);
						} else {
							this.viewOrder(true);
						}
					}
				}
			});
		},

		// 清除所有定时器
		clearTimers() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer);
				this.countdownTimer = null;
			}
			if (this.paymentTimer) {
				clearInterval(this.paymentTimer);
				this.paymentTimer = null;
			}
		},

		// 刷新二维码
		async refreshQRCode() {
			this.loading = true;
			this.countdown = 300; // 重置倒计时
			await this.getConsumerOrderPayAlibaba();
			// this.$message.success('二维码已刷新，请重新扫码支付');
		},

		viewOrder(isPaySuccess) {
			this.clearTimers();
			this.$router.replace({ path: '/OrderDet', query: { orderId: this.$route.query.orderId } });
		},

		async getConsumerOrderPayAlibaba() {
			try {
				let res = await getConsumerOrderPayAlibaba(this.$route.query.orderId);
				this.currentQRCode = res.data;
				this.aliQrcode(res.data);
			} catch (error) {
				this.$message.error('获取支付二维码失败');
				this.loading = false;
			}
		},

		aliQrcode(qrCode) {
			document.getElementById('ali-qrcode').innerHTML = '';
			let qrcode = new QRCode(document.getElementById('ali-qrcode'), {
				width: 198,
				height: 198,
				text: qrCode // 二维码内容
			});
			this.loading = false;
			this.startCountdown();
			this.startPaymentPolling();
		},

		// 格式化时间显示（分:秒）
		formatTime(seconds) {
			const minutes = Math.floor(seconds / 60);
			const remainingSeconds = seconds % 60;
			return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
		}
	}
};
</script>

<style lang="less" scoped>
.pay-type {
	margin-bottom: 30px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	h3 {
		margin: 0;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}
}

.money {
	font-size: 26px;
	font-weight: 700;
	color: #f60;
}

/* 二维码容器样式 */
.qrcode-container {
	position: relative;
	display: inline-block;
	margin: 20px 0;
}

.qrcode {
	display: inline-block;
	overflow: hidden;
	width: 198px;
	height: 198px;
}

/* 二维码蒙版样式 */
.qrcode-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s ease;
}

.qrcode-overlay:hover {
	background-color: rgba(0, 0, 0, 0.8);
}

/* 刷新图标样式 */
.refresh-icon {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: white;
	font-size: 14px;
}

.refresh-icon i {
	font-size: 32px;
	margin-bottom: 8px;
	transition: transform 0.3s ease;
}

.refresh-icon:hover i {
	transform: rotate(180deg);
}

.countdown-timer {
	margin: 10px 0 10px 20px;
	font-size: 16px;
}

.timer-text {
	color: #e6a23c;
	font-weight: bold;
}

.timer-expired {
	color: #f56c6c;
	font-weight: bold;
}

.action-buttons {
	text-align: center;
}

.pay-title {
	color: #4f8dfe;
	text-wechatgn: center;
	line-height: 30px;
	font-size: 16px;
}

.tab-pane-left {
	width: 50%;
	float: left;
}

.tab-pane-left h6 {
	padding: 0;
	margin: 0;
	font-size: 24px;
	margin-bottom: 10px;
}

.tab-pane-right {
	width: 49%;
	float: left;
	height: 100%;
}

.tab-pane-right-img {
	width: 70%;
	height: 100%;
	margin: 30px auto 0;
}

.tab-pane-right-img img {
	height: 100%;
	width: 100%;
}

/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
